export const darkBlue = "#224B6A";
